"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.leadSubmissionApi = void 0;
var leadSubmissionApi = /** @class */ (function () {
    function leadSubmissionApi(local, handleLeadSubmission) {
        this.props = local;
        this.handleLeadSubmission = handleLeadSubmission;
    }
    leadSubmissionApi.prototype.submitLead = function (bookAppointment) {
        if (bookAppointment === void 0) { bookAppointment = false; }
        return __awaiter(this, void 0, void 0, function () {
            var requestModel, requestOptions, apiSuccess;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        //Create request at step 3 (Contact)
                        requestModel = {
                            "MovingFromInput": this.props.values.movingFromAddrComponent.MovingFromInput,
                            "MovingFromAddress": this.props.values.movingFromAddrComponent.MovingFromAddress,
                            "MovingFromCity": this.props.values.movingFromAddrComponent.MovingFromCity,
                            "MovingFromState": this.props.values.movingFromAddrComponent.MovingFromState,
                            "MovingFromZip": this.props.values.movingFromAddrComponent.MovingFromZip,
                            "MovingFromCountryCode": this.props.values.movingFromAddrComponent.MovingFromCountryCode,
                            "MovingFromClientValidated": "true",
                            "MovingToInput": this.props.values.movingToAddrComponent.MovingToInput,
                            "MovingToAddress": this.props.values.movingToAddrComponent.MovingToAddress,
                            "MovingToCity": this.props.values.movingToAddrComponent.MovingToCity,
                            "MovingToState": this.props.values.movingToAddrComponent.MovingToState,
                            "MovingToZip": this.props.values.movingToAddrComponent.MovingToZip,
                            "MovingToCountryCode": this.props.values.movingToAddrComponent.MovingToCountryCode,
                            "MovingToClientValidated": "true",
                            "MoveDate": this.props.values.movingDateString,
                            "home-type": "house",
                            "home-size": this.getHomeSizeforAPI(),
                            "DwellingType": this.getHomeSizeforAPI(),
                            "Name": this.props.values.contactName,
                            "Email": this.props.values.contactEmail,
                            "Phone": this.props.values.contactPhone,
                            "HasVehicle": this.props.values.movingVehicle === "yes" ? "true" : "false",
                            "WidgetSpecificRefCode": this.props.values.referralCode,
                            "RefferalCode": this.props.values.referralCode,
                            "DeviceType": document.getElementById("DeviceType").value,
                            "PrevPageUrlReferrer": this.props.values.prevPageUrlReferral,
                            "VendorName": this.props.values.vendorName,
                            "VendorParms": this.props.values.vendorParms,
                            "VendorId": this.props.values.vendorId,
                            "__RequestVerificationToken": this.props.values.verificationToken,
                            "quote-range": "Medium"
                        };
                        if (bookAppointment) {
                            requestModel = {
                                "MovingFromInput": this.props.values.movingFromAddrComponent.MovingFromInput,
                                "MovingFromAddress": this.props.values.movingFromAddrComponent.MovingFromAddress,
                                "MovingFromCity": this.props.values.movingFromAddrComponent.MovingFromCity,
                                "MovingFromState": this.props.values.movingFromAddrComponent.MovingFromState,
                                "MovingFromZip": this.props.values.movingFromAddrComponent.MovingFromZip,
                                "MovingFromCountryCode": this.props.values.movingFromAddrComponent.MovingFromCountryCode,
                                "MovingFromClientValidated": "true",
                                "MovingToInput": this.props.values.movingToAddrComponent.MovingToInput,
                                "MovingToAddress": this.props.values.movingToAddrComponent.MovingToAddress,
                                "MovingToCity": this.props.values.movingToAddrComponent.MovingToCity,
                                "MovingToState": this.props.values.movingToAddrComponent.MovingToState,
                                "MovingToZip": this.props.values.movingToAddrComponent.MovingToZip,
                                "MovingToCountryCode": this.props.values.movingToAddrComponent.MovingToCountryCode,
                                "MovingToClientValidated": "true",
                                "MoveDate": this.props.values.movingDateString,
                                "home-type": "house",
                                "home-size": this.getHomeSizeforAPI(),
                                "DwellingType": this.getHomeSizeforAPI(),
                                "Name": this.props.values.contactName,
                                "Email": this.props.values.contactEmail,
                                "Phone": this.props.values.contactPhone,
                                "HasVehicle": this.props.values.movingVehicle === "yes" ? "true" : "false",
                                "AgentCode": this.props.values.agentCode,
                                "CalendarAppointmentDate": this.props.values.appointmentDateString,
                                "CalendarAppointmentTime": this.props.values.appointmentTimeString.split(" ")[0],
                                "CalendarAppointmentTimeOfDay": this.props.values.appointmentTimeString.split(" ")[1],
                                "CalendarDuration": "1 hour",
                                "AMCSalesPersonPartyID": this.props.values.salesPersonID,
                                "CalendarSalesPersonID": this.props.values.salesPersonID,
                                "SalesPerson": this.props.values.salesPersonName,
                                "CalendarUserName": this.props.values.calendarUserName,
                                "CalendarURI": this.props.values.calendarURL,
                                "CalendarURL": this.props.values.calendarURL,
                                "IsCAS": this.props.values.isCAS,
                                "AllocationId": this.props.values.agentAllocationId,
                                "WidgetSpecificRefCode": this.props.values.referralCode,
                                "RefferalCode": this.props.values.referralCode,
                                "DeviceType": document.getElementById("DeviceType").value,
                                "PrevPageUrlReferrer": this.props.values.prevPageUrlReferral,
                                "VendorName": this.props.values.vendorName,
                                "VendorParms": this.props.values.vendorParms,
                                "VendorId": this.props.values.vendorId,
                                "__RequestVerificationToken": this.props.values.verificationToken,
                                "quote-range": "Medium"
                            };
                        }
                        requestOptions = {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                                'X-Requested-With': 'XMLHttpRequest'
                            },
                            body: new URLSearchParams(requestModel)
                        };
                        apiSuccess = false;
                        return [4 /*yield*/, fetch('/free-quote/request-estimate', requestOptions)
                                .then(function (response) {
                                if (!response.ok) {
                                    throw new Error('error => Error while Submitting Lead');
                                }
                                return response.json();
                            })
                                .then(function (data) {
                                if (bookAppointment) {
                                    _this.handleLeadSubmission(data);
                                }
                                apiSuccess = true;
                            }, function (error) {
                                console.log(error);
                                if (bookAppointment) {
                                    _this.handleLeadSubmission(error);
                                }
                                apiSuccess = false;
                            })
                                .catch(function (error) {
                                console.log(error);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, apiSuccess];
                }
            });
        });
    };
    leadSubmissionApi.prototype.getHomeSizeforAPI = function () {
        switch (this.props.values.houseSize) {
            case "small":
                return "H1";
            case "medium":
                return "H2";
            case "large":
                return "H4";
            default:
                return "H2";
        }
    };
    return leadSubmissionApi;
}());
exports.leadSubmissionApi = leadSubmissionApi;
//# sourceMappingURL=leadSubmissionApi.js.map